var map = {
	"./custom/app/shared/object-collection/shared/badges/my-dspace-status-badge/my-dspace-status-badge.component": [
		73613,
		[
			"common",
			"src_themes_custom_app_shared_object-collection_shared_badges_my-dspace-status-badge_my-dspace-ffcbf3"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87596;
module.exports = webpackAsyncContext;